import { render, staticRenderFns } from "./PerformanceSummary.vue?vue&type=template&id=1f5a1a4a&"
import script from "./PerformanceSummary.vue?vue&type=script&lang=js&"
export * from "./PerformanceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports